import { withAuthenticationRequired } from '@auth0/auth0-react';
import { RouteLoader } from '#components/Loader/RouteLoader';

const RedirectLoader = () => <RouteLoader />;

export const RequireAuthentication = ({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element => {
  const Content = withAuthenticationRequired(() => children, {
    onRedirecting: RedirectLoader,
  });

  return <Content />;
};
